export default __webpack_public_path__ + "static/media/playscreen.dfd77e08.png";